module.exports = __webpack_public_path__ + "view.svg?2e98c7db1a26a8ca7bbc755a64d3a706";